export const HideFromHeaderBox = 'hide-from-header-box' as const;
